const initialState = {
  links: [],
  isLoading: false,
  isLoadingFailed: false,
  isPopulated: false,
}

export default initialState
